import React from "react"
import Image from "./itemImage"
import { Link } from "gatsby"
import { Box, Description, Title } from "./styled/styles"
import styled from "styled-components/macro"

export default props => {
  const name = props.data.name.toLowerCase().split(" ").join("").replace("!", "")

  if (props.mask) {
    return (
      <Link to={`/${name}`} css={`text-decoration: none;`}>
        <Box theme={props.theme}>
          <Image filename={props.mask ? `${name}mask` : name} alt={props.data.name} />
          <Title theme={props.theme}>{props.data.name}</Title>
          <Description theme={props.theme}>{props.data.description}</Description>
        </Box>
      </Link>
    )
  }

  return (
    <Box theme={props.theme}>
      <Image filename={props.mask ? `${name}mask` : name} alt={props.data.name} />
      <Title theme={props.theme}>{props.data.name}</Title>
      <Description theme={props.theme}>{props.data.description}</Description>
    </Box>
  )
}
